import { nodeId } from "../../../../utils/utility";

export const createInitialEdges = (airDevices = [], hvacs = []) => {
  const usedHandles = {};
  const edges = [];

  airDevices.forEach(device => {
    if (!device['linked-hvac']) return;

    const hvac = hvacs.find(h => h['device-id'] === device['linked-hvac']);
    if (!hvac) return;

    const sourceId = nodeId(device.name, device['device-id']);
    const targetId = nodeId(hvac.name, hvac['device-id']);

    if (!usedHandles[targetId]) usedHandles[targetId] = new Set();

    const targetHandle =
      device.primary || !usedHandles[targetId].has('left') ? 'left' : 'bottom';

    usedHandles[targetId].add(targetHandle);

    edges.push({
      id: `${sourceId}-${targetId}`,
      source: sourceId,
      sourceHandle: 'right',
      target: targetId,
      targetHandle,
      type: 'bezier',
      style: { stroke: '#E87828', strokeWidth: 2 }
    });
  });

  airDevices
    .filter(d => !d.primary && d['primary-device-id'])
    .forEach(d => {
      const parent = airDevices.find(p => p['device-id'] === d['primary-device-id']);
      if (!parent) return;

      edges.push({
        id: `${nodeId(parent.name, parent['device-id'])}-${nodeId(d.name, d['device-id'])}`,
        source: nodeId(parent.name, parent['device-id']),
        sourceHandle: 'bottom',
        target: nodeId(d.name, d['device-id']),
        targetHandle: 'left',
        type: 'bezier',
        animated: true,
        style: { stroke: '#E87828', strokeWidth: 2 }
      });
    });

  return edges;
};
